import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getParlamentDecisionById, getParlamentDecisions } from '../../api/councilService';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';
import QuickMenu from '../../components/QuickMenu/QuickMenu';

const formatDecisionDate = (dateString) => {
  if (!dateString) {
    return '-';
  }

  const date = new Date(dateString);
  return Number.isNaN(date.getTime()) ? dateString : format(date, 'dd MMMM yyyy', { locale: tr });
};

export default function CouncilDetail() {
  const params = useParams();
  const location = useLocation();
  const guidFromState = location.state?.guid;
  const routeKey = params.urlTag || params.id || params['*'];
  const [decision, setDecision] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDecisionDetail = async () => {
      try {
        setLoading(true);
        setError(null);
        setDecision(null);

        let resolvedGuid = guidFromState;

        if (!resolvedGuid && routeKey) {
          const decisionsResponse = await getParlamentDecisions(1, 1000);

          if (decisionsResponse.isSuccess && decisionsResponse.data?.items) {
            const matchedDecision = decisionsResponse.data.items.find(
              (item) => item.urlTag === routeKey || item.guid === routeKey
            );

            if (matchedDecision) {
              resolvedGuid = matchedDecision.guid;
            } else {
              setError('Karar bulunamadı');
              return;
            }
          } else {
            setError('Kararlar yüklenirken bir hata oluştu');
            return;
          }
        }

        if (!resolvedGuid) {
          setError('Karar bilgisi bulunamadı');
          return;
        }

        const response = await getParlamentDecisionById(resolvedGuid);

        if (response.isSuccess && response.data) {
          setDecision(response.data);
        } else {
          setError('Karar detayı yüklenirken bir hata oluştu');
        }
      } catch (err) {
        setError('Karar detayı yüklenirken bir hata oluştu');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDecisionDetail();
  }, [guidFromState, routeKey]);

  const handleDownload = () => {
    if (decision?.fileUrl) {
      window.open(decision.fileUrl, '_blank');
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
      </div>
    );
  }

  if (error || !decision) {
    return (
      <div className="alert alert-danger m-5">
        {error || 'Karar bulunamadı'}
      </div>
    );
  }

  return (
    <div>
      <div className="container py-4">
        <div className="row">
          <QuickMenu />

          <div className="col-md-10">
            <div className="council-detail">
              <div className="council-detail-title">
                <h2>{decision.header}</h2>
              </div>
              <div className="council-detail-meta">
                <p><span>Tarih:</span>{formatDecisionDate(decision.date)} </p>
                <p><span>Karar No:</span>{decision.decisionsNo || '-'} </p>
              </div>
              <div className="council-detail-content">
                <div
                  className="council-detail-text-content"
                  dangerouslySetInnerHTML={{ __html: decision.detail || '' }}
                />
              </div>

              <div className="council-detail-boxes">
                <div className="council-detail-box">
                  <div className="council-detail-box-left">
                    <h4>{decision.header}</h4>
                    <span>{formatDecisionDate(decision.date)} </span>
                  </div>
                  <div className="council-detail-box-right">
                    {decision.fileUrl && (
                      <button type="button" onClick={handleDownload}>İndir</button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
